/*
 * Trade Secrets product finder: a chat-style guided assistant ("Help me find"). The shopper answers a few questions and gets
 * matching products. For hair it uses the storefront filters (custom.hair_concerns, hair_type, hair_texture, ingredient_preferences,
 * size) on a category page and shows the first matches in the chat, with a link to the full filtered page. For the other
 * departments it points to the right category pages. No server and no external service: everything is the store's own pages.
 *
 * Markup is built here (textContent only). Styles: assets/ts-assistant.css. Loaded by snippets/ts-assistant.liquid.
 */
(function () {
  if (window.__tsAssistant) return;
  window.__tsAssistant = true;

  var lang = (document.documentElement.lang || 'en').toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FILTER = 'filter.p.m.custom.';

  function t(o) {
    return typeof o === 'string' ? o : o[lang] || o.en;
  }

  var S = {
    open: { en: 'Help me find', fr: 'Aidez-moi à trouver' },
    title: { en: 'Product finder', fr: 'Trouveur de produits' },
    close: { en: 'Close', fr: 'Fermer' },
    back: { en: 'Back', fr: 'Retour' },
    restart: { en: 'Start over', fr: 'Recommencer' },
    cont: { en: 'Continue', fr: 'Continuer' },
    skip: { en: 'Skip', fr: 'Passer' },
    hello: {
      en: "Hi! I'll help you find the right products. What are you looking for?",
      fr: 'Bonjour! Je vous aide à trouver les bons produits. Que cherchez-vous?'
    },
    pickMany: { en: 'Pick as many as you like, then continue.', fr: 'Choisissez-en autant que vous voulez, puis continuez.' },
    searching: { en: 'Looking for matches…', fr: 'Recherche en cours…' },
    seeAll: { en: 'See all {n} products', fr: 'Voir les {n} produits' },
    seeAllOne: { en: 'See this product', fr: 'Voir ce produit' },
    found: { en: 'I found {n} products that match.', fr: "J'ai trouvé {n} produits qui correspondent." },
    foundOne: { en: 'I found 1 product that matches.', fr: "J'ai trouvé 1 produit qui correspond." },
    broader: {
      en: "Nothing matched every answer, so I loosened the last choices. Here's {n} products that are close.",
      fr: "Rien ne correspondait à toutes les réponses, alors j'ai élargi les derniers choix. Voici {n} produits proches."
    },
    none: {
      en: "I couldn't find a match. Try starting over or use the search bar.",
      fr: "Je n'ai pas trouvé de correspondance. Essayez de recommencer ou utilisez la recherche."
    },
    error: {
      en: 'Something went wrong loading the products. You can still browse the category.',
      fr: 'Un problème est survenu. Vous pouvez quand même parcourir la catégorie.'
    },
    browse: { en: 'Browse {name}', fr: 'Parcourir {name}' },
    searchPrompt: {
      en: 'Sure. Type what you are looking for in the search bar.',
      fr: 'Bien sûr. Tapez ce que vous cherchez dans la barre de recherche.'
    },
    openSearch: { en: 'Open search', fr: 'Ouvrir la recherche' },
    linksIntro: { en: 'Great choice. Where would you like to start?', fr: 'Bon choix. Par où voulez-vous commencer?' },
    more: { en: 'Anything else?', fr: 'Autre chose?' }
  };

  var TOP = [
    { id: 'hair', label: { en: 'Hair care & styling', fr: 'Soins et coiffage' } },
    { id: 'tools', label: { en: 'Hair tools & appliances', fr: 'Outils et appareils' } },
    { id: 'nails', label: { en: 'Nails', fr: 'Ongles' } },
    { id: 'skin', label: { en: 'Skin & body', fr: 'Peau et corps' } },
    { id: 'makeup', label: { en: 'Makeup', fr: 'Maquillage' } },
    { id: 'men', label: { en: 'Men', fr: 'Hommes' } },
    { id: 'gifts', label: { en: 'Gifts', fr: 'Cadeaux' } },
    { id: 'sale', label: { en: 'On sale', fr: 'En solde' } },
    { id: 'new', label: { en: 'New arrivals', fr: 'Nouveautés' } },
    { id: 'search', label: { en: 'I know what I want', fr: 'Je sais ce que je veux' } }
  ];

  // Departments that are just category links.
  var LINKS = {
    tools: [
      ['flat-irons-1', { en: 'Flat irons', fr: 'Fers plats' }],
      ['curling-irons-1', { en: 'Curling irons', fr: 'Fers à friser' }],
      ['hair-dryer', { en: 'Hair dryers', fr: 'Séchoirs' }],
      ['hair-tools', { en: 'All hair tools', fr: 'Tous les outils' }]
    ],
    nails: [
      ['nails-care', { en: 'Polish & nail care', fr: 'Vernis et soins' }],
      ['nail-kits-1', { en: 'False nails & kits', fr: 'Faux ongles et trousses' }],
      ['nail-tools-1', { en: 'Nail tools', fr: 'Outils pour ongles' }]
    ],
    skin: [
      ['skin-care-1', { en: 'Skin care', fr: 'Soins de la peau' }],
      ['body-care-1', { en: 'Body care', fr: 'Soins du corps' }],
      ['makeup-removers-1', { en: 'Makeup removers', fr: 'Démaquillants' }]
    ],
    makeup: [
      ['makeup-1', { en: 'Makeup', fr: 'Maquillage' }],
      ['makeup-brushes-tools-1', { en: 'Brushes & tools', fr: 'Pinceaux et outils' }]
    ],
    men: [
      ['men', { en: 'Everything for men', fr: 'Tout pour hommes' }],
      ['men-shampoo', { en: 'Shampoo', fr: 'Shampooing' }],
      ['men-styling', { en: 'Styling', fr: 'Coiffage' }],
      ['men-hair-tools', { en: 'Hair tools', fr: 'Outils' }]
    ],
    gifts: [['gifts', { en: 'Gifts', fr: 'Cadeaux' }]],
    sale: [['price-drops', { en: 'Price drops', fr: 'Baisses de prix' }]],
    new: [['new', { en: 'New arrivals', fr: 'Nouveautés' }]]
  };

  var NOT_SURE = { en: 'Not sure', fr: 'Pas certain' };

  // Hair questions, in order. key = filter name (null for the category), type = single or multi.
  var HAIR = [
    {
      key: 'base',
      type: 'single',
      q: { en: 'What kind of product?', fr: 'Quel type de produit?' },
      opts: [
        ['shampoo', { en: 'Shampoo', fr: 'Shampooing' }],
        ['conditioners-1', { en: 'Conditioner', fr: 'Revitalisant' }],
        ['hair-masks-treatments', { en: 'Mask or treatment', fr: 'Masque ou traitement' }],
        ['styling', { en: 'Styling', fr: 'Coiffage' }],
        ['hair-oil', { en: 'Oil or serum', fr: 'Huile ou sérum' }],
        ['leave-in', { en: 'Leave-in', fr: 'Sans rinçage' }],
        ['dry-shampoo', { en: 'Dry shampoo', fr: 'Shampooing sec' }],
        ['hair-care', { en: 'Anything for hair', fr: "N'importe quoi pour les cheveux" }]
      ]
    },
    {
      key: 'hair_concerns',
      type: 'multi',
      q: { en: 'What would you like to fix or improve?', fr: 'Que voulez-vous corriger ou améliorer?' },
      opts: [
        ['Frizz', { en: 'Frizz', fr: 'Frisottis' }],
        ['Dryness', { en: 'Dryness', fr: 'Sécheresse' }],
        ['Damage / Split Ends / Breakage', { en: 'Damage or split ends', fr: 'Dommages ou fourches' }],
        ['Thinning / Hair Loss', { en: 'Thinning or hair loss', fr: 'Amincissement ou perte' }],
        ['Volumizing', { en: 'Volume', fr: 'Volume' }],
        ['Shine', { en: 'Shine', fr: 'Éclat' }],
        ['Hold / Styling / Style Longevity', { en: 'Hold & style longevity', fr: 'Tenue du style' }],
        ['Oily Scalp', { en: 'Oily scalp', fr: 'Cuir chevelu gras' }],
        ['Dry / Flaky Scalp', { en: 'Dry or flaky scalp', fr: 'Cuir chevelu sec ou squameux' }],
        ['Scalp Buildup', { en: 'Scalp buildup', fr: 'Accumulation' }]
      ]
    },
    {
      key: 'hair_type',
      type: 'single',
      q: { en: 'How thick is your hair?', fr: 'Quelle est l\'épaisseur de vos cheveux?' },
      opts: [
        ['Fine', { en: 'Fine', fr: 'Fins' }],
        ['Medium', { en: 'Medium', fr: 'Moyens' }],
        ['Thick', { en: 'Thick', fr: 'Épais' }]
      ],
      skip: NOT_SURE
    },
    {
      key: 'hair_texture',
      type: 'single',
      q: { en: 'What is your hair texture?', fr: 'Quelle est la texture de vos cheveux?' },
      opts: [
        ['Wavy', { en: 'Wavy', fr: 'Ondulés' }],
        ['Curly', { en: 'Curly', fr: 'Bouclés' }],
        ['Coily', { en: 'Coily', fr: 'Crépus' }]
      ],
      skip: { en: 'Straight / not sure', fr: 'Lisses / pas certain' }
    },
    {
      key: 'ingredient_preferences',
      type: 'single',
      q: { en: 'Is one of these a must-have?', fr: "L'un de ces critères est-il essentiel?" },
      opts: [
        ['Vegan', { en: 'Vegan', fr: 'Végane' }],
        ['Cruelty-free', { en: 'Cruelty-free', fr: 'Sans cruauté' }],
        ['Paraben-free', { en: 'Paraben-free', fr: 'Sans parabènes' }],
        ['Sulfate-free', { en: 'Sulfate-free', fr: 'Sans sulfates' }],
        ['Silicone-free', { en: 'Silicone-free', fr: 'Sans silicones' }]
      ],
      skip: { en: 'No preference', fr: 'Aucune préférence' }
    },
    {
      key: 'size',
      type: 'single',
      q: { en: 'What size?', fr: 'Quel format?' },
      opts: [
        ['Travel size', { en: 'Travel size', fr: 'Format voyage' }],
        ['Regular size', { en: 'Regular size', fr: 'Format régulier' }],
        ['Jumbo size', { en: 'Jumbo size', fr: 'Grand format' }]
      ],
      skip: { en: 'Any size', fr: "N'importe quel format" }
    }
  ];

  // When nothing matches, drop these answers one at a time, in this order.
  var RELAX = ['size', 'ingredient_preferences', 'hair_texture', 'hair_type'];

  var els = {};
  var state;
  var history;
  var seq = 0;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function fill(str, vars) {
    return str.replace(/\{(\w+)\}/g, function (m, k) {
      return vars && vars[k] != null ? vars[k] : m;
    });
  }

  /* ---------- UI shell ---------- */
  function build() {
    var panel = el('section', 'ts-ai__panel');
    panel.id = 'ts-ai-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', t(S.title));
    panel.hidden = true;
    panel.setAttribute('tabindex', '-1');

    var head = el('div', 'ts-ai__head');
    var back = el('button', 'ts-ai__icon-btn ts-ai__back', '←');
    back.type = 'button';
    back.setAttribute('aria-label', t(S.back));
    var title = el('span', 'ts-ai__title', t(S.title));
    var restart = el('button', 'ts-ai__text-btn', t(S.restart));
    restart.type = 'button';
    var close = el('button', 'ts-ai__icon-btn', '×');
    close.type = 'button';
    close.setAttribute('aria-label', t(S.close));
    head.appendChild(back);
    head.appendChild(title);
    head.appendChild(restart);
    head.appendChild(close);

    var msgs = el('div', 'ts-ai__messages');
    msgs.setAttribute('aria-live', 'polite');

    panel.appendChild(head);
    panel.appendChild(msgs);
    document.body.appendChild(panel);

    els = { panel: panel, msgs: msgs, back: back, restart: restart, close: close };

    /* The header icon (snippets/ts-assistant-button.liquid) opens and closes the panel. */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-ts-ai-open]');
      if (!trigger) return;
      if (panel.hidden) openPanel(trigger);
      else closePanel();
    });
    close.addEventListener('click', closePanel);
    restart.addEventListener('click', start);
    back.addEventListener('click', goBack);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        closePanel();
        if (lastTrigger) lastTrigger.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (!panel.hidden) placePanel();
    });
  }

  var lastTrigger = null;

  function setTriggers(open) {
    document.querySelectorAll('[data-ts-ai-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Wide screens: the panel drops down from just under the header icon. Phones: bottom sheet (CSS). */
  function placePanel() {
    var p = els.panel;
    if (window.innerWidth < 750 || !lastTrigger) {
      p.style.top = '';
      p.style.height = '';
      return;
    }
    var top = Math.round(lastTrigger.getBoundingClientRect().bottom) + 10;
    p.style.top = top + 'px';
    p.style.height = Math.max(320, Math.min(640, window.innerHeight - top - 16)) + 'px';
  }

  /* The NEW badge on the header icon goes away once the visitor has opened the finder. */
  var SEEN_KEY = 'ts_ai_seen';

  function hideNewBadge(remember) {
    if (remember) {
      try {
        localStorage.setItem(SEEN_KEY, '1');
      } catch (e) {}
    }
    document.querySelectorAll('[data-ts-ai-new]').forEach(function (b) {
      b.hidden = true;
    });
  }

  function openPanel(trigger) {
    hideNewBadge(true);
    lastTrigger = trigger || lastTrigger || document.querySelector('[data-ts-ai-open]');
    els.panel.hidden = false;
    placePanel();
    setTriggers(true);
    document.documentElement.classList.add('ts-ai-open');
    if (!els.msgs.children.length) start();
    els.panel.focus();
  }

  function closePanel() {
    els.panel.hidden = true;
    setTriggers(false);
    document.documentElement.classList.remove('ts-ai-open');
  }

  function scrollDown() {
    els.msgs.scrollTop = els.msgs.scrollHeight;
  }

  function bubble(kind, text) {
    var b = el('div', 'ts-ai__bubble ts-ai__bubble--' + kind, text);
    els.msgs.appendChild(b);
    scrollDown();
    return b;
  }

  function lockOptions() {
    els.msgs.querySelectorAll('.ts-ai__options:not([data-locked])').forEach(function (o) {
      o.setAttribute('data-locked', '');
      o.querySelectorAll('button, a').forEach(function (b) {
        if (b.tagName === 'BUTTON') b.disabled = true;
      });
    });
  }

  function chips(options, onPick, opts) {
    opts = opts || {};
    var wrap = el('div', 'ts-ai__options');
    options.forEach(function (o) {
      var b;
      if (o.href) {
        b = el('a', 'ts-ai__chip', o.label);
        b.href = o.href;
      } else {
        b = el('button', 'ts-ai__chip', o.label);
        b.type = 'button';
        if (opts.multi) b.setAttribute('aria-pressed', 'false');
        b.addEventListener('click', function () {
          if (opts.multi) {
            var on = b.getAttribute('aria-pressed') !== 'true';
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (opts.onToggle) opts.onToggle();
          } else {
            onPick(o);
          }
        });
      }
      b.dataset.value = o.value == null ? '' : o.value;
      wrap.appendChild(b);
    });
    els.msgs.appendChild(wrap);
    scrollDown();
    return wrap;
  }

  /* ---------- flow ---------- */
  function start() {
    seq++;
    els.msgs.textContent = '';
    state = { dept: null, base: null, answers: {} };
    history = [];
    updateBack();
    bubble('bot', t(S.hello));
    chips(
      TOP.map(function (d) {
        return { label: t(d.label), value: d.id };
      }),
      function (o) {
        snapshot();
        lockOptions();
        bubble('user', o.label);
        pickDept(o.value);
      }
    );
  }

  function snapshot() {
    history.push({ nodes: els.msgs.children.length, state: JSON.stringify(state) });
    updateBack();
  }

  function updateBack() {
    els.back.style.visibility = history && history.length ? 'visible' : 'hidden';
  }

  function goBack() {
    var h = history.pop();
    if (!h) return;
    seq++;
    while (els.msgs.children.length > h.nodes) els.msgs.removeChild(els.msgs.lastChild);
    state = JSON.parse(h.state);
    // Unlock the options that were showing at that point.
    var all = els.msgs.querySelectorAll('.ts-ai__options');
    var last = all[all.length - 1];
    if (last) {
      last.removeAttribute('data-locked');
      last.querySelectorAll('button').forEach(function (b) {
        b.disabled = false;
      });
    }
    updateBack();
    scrollDown();
  }

  function pickDept(id) {
    state.dept = id;
    if (id === 'hair') return askHair(0);
    if (id === 'search') return openSearch();
    var links = LINKS[id];
    bubble('bot', t(S.linksIntro));
    chips(
      links.map(function (l) {
        return { label: t(l[1]), href: root + 'collections/' + l[0] };
      }),
      null
    );
    moreOptions();
  }

  function moreOptions() {
    var wrap = el('div', 'ts-ai__options ts-ai__options--footer');
    var b = el('button', 'ts-ai__chip ts-ai__chip--ghost', t(S.restart));
    b.type = 'button';
    b.addEventListener('click', start);
    wrap.appendChild(b);
    els.msgs.appendChild(wrap);
    scrollDown();
  }

  function openSearch() {
    bubble('bot', t(S.searchPrompt));
    var wrap = el('div', 'ts-ai__options');
    var b = el('button', 'ts-ai__chip', t(S.openSearch));
    b.type = 'button';
    b.addEventListener('click', function () {
      closePanel();
      var toggle = document.querySelector('.ts-search-toggle');
      var header = document.querySelector('#header-component');
      if (toggle && getComputedStyle(toggle).display !== 'none' && header && !header.hasAttribute('data-ts-search-open')) {
        toggle.click();
        return;
      }
      var input = Array.prototype.slice.call(document.querySelectorAll('.ts-search-bar__input')).filter(function (i) {
        return i.offsetParent !== null;
      })[0];
      if (input) input.focus();
    });
    wrap.appendChild(b);
    els.msgs.appendChild(wrap);
    moreOptions();
  }

  function askHair(i) {
    var step = HAIR[i];
    if (!step) return showResults();
    bubble('bot', t(step.q) + (step.type === 'multi' ? ' ' + t(S.pickMany) : ''));

    var opts = step.opts.map(function (o) {
      return { label: t(o[1]), value: o[0] };
    });

    function commit(values, label) {
      snapshot();
      lockOptions();
      bubble('user', label);
      if (step.key === 'base') state.base = values[0];
      else if (values.length) state.answers[step.key] = values;
      askHair(i + 1);
    }

    if (step.type === 'multi') {
      var go;
      var wrap = chips(opts, null, {
        multi: true,
        onToggle: function () {
          var n = wrap.querySelectorAll('[aria-pressed="true"]').length;
          go.textContent = n ? t(S.cont) : t(S.skip);
        }
      });
      go = el('button', 'ts-ai__primary', t(S.skip));
      go.type = 'button';
      go.addEventListener('click', function () {
        var picked = Array.prototype.slice.call(wrap.querySelectorAll('[aria-pressed="true"]')).map(function (b) {
          return { value: b.dataset.value, label: b.textContent };
        });
        commit(
          picked.map(function (p) {
            return p.value;
          }),
          picked.length
            ? picked
                .map(function (p) {
                  return p.label;
                })
                .join(', ')
            : t(S.skip)
        );
      });
      // The button lives inside the options wrapper so it locks together with the chips.
      wrap.appendChild(go);
      scrollDown();
    } else {
      if (step.skip) opts.push({ label: t(step.skip), value: '', skip: true });
      chips(opts, function (o) {
        commit(o.skip ? [] : [o.value], o.label);
      });
    }
  }

  /* ---------- results ---------- */
  function paramsFor(answers) {
    var p = [];
    Object.keys(answers).forEach(function (k) {
      answers[k].forEach(function (v) {
        p.push(FILTER + k + '=' + encodeURIComponent(v));
      });
    });
    return p.join('&');
  }

  function urlFor(base, answers) {
    var q = paramsFor(answers);
    return root + 'collections/' + base + (q ? '?' + q : '');
  }

  function fetchResults(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('bad status');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var countEl = doc.querySelector('.products-count-wrapper');
        var m = countEl && countEl.textContent.replace(/,/g, '').match(/\d+/);
        var cards = Array.prototype.slice.call(doc.querySelectorAll('.product-grid__item')).slice(0, 6).map(function (li) {
          var a = li.querySelector('a[href*="/products/"]');
          var img = li.querySelector('img');
          var vendor = li.querySelector('[class*="__vendor"]');
          var title = li.querySelector('[class*="__product_title"]');
          var price = li.querySelector('.price');
          return {
            href: a ? a.getAttribute('href') : '#',
            img: img ? (img.getAttribute('src') || '').replace(/width=\d+/, 'width=320') : '',
            alt: img ? img.getAttribute('alt') || '' : '',
            vendor: vendor ? vendor.textContent.trim() : '',
            title: (title ? title.textContent : (img && img.getAttribute('alt')) || '').trim(),
            price: price ? (price.querySelector('bdi') || price).textContent.replace(/\s+/g, ' ').trim() : ''
          };
        });
        return { count: m ? parseInt(m[0], 10) : cards.length, cards: cards };
      });
  }

  function showResults() {
    var mySeq = seq;
    var base = state.base || 'hair-care';
    var answers = JSON.parse(JSON.stringify(state.answers));
    var loading = bubble('bot', t(S.searching));
    var relaxed = false;

    function attempt(ans, relaxIdx) {
      var url = urlFor(base, ans);
      return fetchResults(url).then(function (res) {
        if (res.count === 0 && relaxIdx < RELAX.length) {
          var next = JSON.parse(JSON.stringify(ans));
          var dropped = false;
          for (var i = relaxIdx; i < RELAX.length && !dropped; i++) {
            if (next[RELAX[i]]) {
              delete next[RELAX[i]];
              dropped = true;
              relaxed = true;
              return attempt(next, i + 1);
            }
          }
        }
        res.url = url;
        return res;
      });
    }

    attempt(answers, 0)
      .then(function (res) {
        if (mySeq !== seq) return;
        loading.remove();
        if (!res.count) {
          bubble('bot', t(S.none));
        } else {
          var msg = res.count === 1 ? t(S.foundOne) : fill(t(relaxed ? S.broader : S.found), { n: res.count });
          bubble('bot', msg);
          els.msgs.appendChild(cardsEl(res.cards));
          var all = el('a', 'ts-ai__primary ts-ai__primary--link', res.count === 1 ? t(S.seeAllOne) : fill(t(S.seeAll), { n: res.count }));
          all.href = res.count === 1 && res.cards[0] ? res.cards[0].href : res.url;
          els.msgs.appendChild(all);
        }
        moreOptions();
        scrollDown();
      })
      .catch(function () {
        if (mySeq !== seq) return;
        loading.remove();
        bubble('bot', t(S.error));
        var b = el('a', 'ts-ai__primary ts-ai__primary--link', fill(t(S.browse), { name: '' }).trim());
        b.href = root + 'collections/' + base;
        els.msgs.appendChild(b);
        moreOptions();
      });
  }

  function cardsEl(cards) {
    var grid = el('div', 'ts-ai__cards');
    cards.forEach(function (c) {
      var a = el('a', 'ts-ai__card');
      a.href = c.href;
      if (c.img) {
        var im = el('img', 'ts-ai__card-img');
        im.src = c.img;
        im.alt = c.alt;
        im.loading = 'lazy';
        a.appendChild(im);
      }
      if (c.vendor) a.appendChild(el('span', 'ts-ai__card-vendor', c.vendor));
      a.appendChild(el('span', 'ts-ai__card-title', c.title));
      if (c.price) a.appendChild(el('span', 'ts-ai__card-price', c.price));
      grid.appendChild(a);
    });
    return grid;
  }

  function init() {
    try {
      if (localStorage.getItem(SEEN_KEY)) hideNewBadge(false);
    } catch (e) {}
    build();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
